import { useCallback } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";

/** Returns an error message, or null when the profile form is valid. */
export function validateProfile(profile) {
  if (!profile.current_password) return "Ingresa tu contraseña actual para confirmar los cambios";
  if (!profile.new_password && !profile.confirm_password) return null;
  if (profile.new_password !== profile.confirm_password) return "La nueva contraseña y la confirmación no coinciden";
  if (profile.new_password.length < 8) return "La nueva contraseña debe tener al menos 8 caracteres";
  return null;
}

function profilePayload(profile, currentUser) {
  const payload = { current_password: profile.current_password, display_name: profile.display_name };
  const email = profile.email?.trim();
  if (email && email.toLowerCase() !== (currentUser?.email || "").toLowerCase()) payload.email = email;
  if (profile.new_password) payload.new_password = profile.new_password;
  return payload;
}

export function useProfileSave() {
  return useCallback(async (profile, currentUser, refreshUser) => {
    const error = validateProfile(profile);
    if (error) {
      toast.error(error);
      return { ok: false };
    }
    try {
      const { data } = await api.put("/auth/profile", profilePayload(profile, currentUser));
      if (data?.user) refreshUser?.(data.user);
      toast.success(data?.message || "Perfil actualizado");
      return { ok: true };
    } catch (e) {
      toast.error(formatApiError(e, "Error al actualizar el perfil"));
      return { ok: false };
    }
  }, []);
}
